import { API_CONFIG } from '../config/apiConfig'
import type { Clinic } from '../types/api'

export const clinicsApi = {
  // GET /clinic
  async getClinics(): Promise<Clinic[]> {
    const response = await fetch(`${API_CONFIG.BASE_URL}/clinic`)
    
    if (!response.ok) {
      throw new Error(`Failed to fetch clinics: ${response.statusText}`)
    }
    
    const data = await response.json()
    // Handle new paginated response format - extract clinics from items array
    return data.items || data
  },
}